import React, { useState, useEffect } from 'react';
import {
  DashboardModalSidebar,
  ModalTab,
  ModalSubTab,
  ModalTableRow,
} from '../../../modules/unsw-modals';
import {
  IQuestionnaireResponse,
  QuestionnaireResponseItemComponent,
  IQuestionnaireResponseItemAnswerComponent,
  IQuestionnaireResponseItemGroupComponent,
  QuestionnaireResponseAnswerComponent,
} from '../../../modules/unsw-fhir/QuestionnaireResponse';
import {
  isQuestionnaireResponseItemGroup,
  isQuestionnaireResponseItemAnswer,
  isReferenceAnswerComponent,
  isBooleanAnswerComponent,
} from '../../../modules/unsw-fhir/QuestionnaireResponse/typeGuards';
import * as x from '../../../modules/unsw-fhir/QuestionnaireResponse/typeGuards';
import CristalScore from './CristalScore';
import { usePatient } from '../../../contexts/patient';
import { getQuestionnaireResponsesByPatientId } from '../../../apis/questionnaireResponse';
import QuestionnaireResponseProvider from '../../Providers/QuestionnnaireResponse';
import { QuestionnaireResponseContext } from '../../../contexts/questionnaireResponse';
import moment from 'moment';

const answer2String = (answer: QuestionnaireResponseAnswerComponent) => {
  if (isBooleanAnswerComponent(answer)) return answer.valueBoolean.toString();
  if (isReferenceAnswerComponent(answer))
    return (
      answer.valueReference.reference ||
      (answer.valueReference.identifier
        ? answer.valueReference.identifier.value
        : null) ||
      answer.valueReference.display ||
      answer.valueReference.id ||
      'Error'
    );
  if (x.isAttachmentAnswerComponent(answer)) return 'attachment';
  if (x.isCodingAnswerComponent(answer))
    return answer.valueCoding.display || answer.valueCoding.code || '';
  if (x.isStringAnswerComponent(answer)) return answer.valueString;
  if (x.isIntegerAnswerComponent(answer)) return answer.valueInteger.toString();
  if (x.isDecimalAnswerComponent(answer)) return answer.valueDecimal.toString();
  if (x.isDateAnswerComponent(answer))
    return moment(answer.valueDate).format('DD-MM-YYYY');

  throw new Error('Could not convert answer Item to string');
};

const answers2String = (answers?: QuestionnaireResponseAnswerComponent[]) => {
  if (!answers) return '';

  return answers.map(ans => answer2String(ans));
};

const SectionRow = ({
  item,
  text,
}: IQuestionnaireResponseItemGroupComponent) => (
  <ModalSubTab title={text || ''}>
    {item ? item.map(i => <Row key={i.linkId} {...i} />) : null}
  </ModalSubTab>
);

const QuestionRow = (props: IQuestionnaireResponseItemAnswerComponent) => (
  <ModalTableRow
    text={props.text || ''}
    answer={answers2String(props.answer)}
  />
);

const Row = (props: QuestionnaireResponseItemComponent) =>
  isQuestionnaireResponseItemGroup(props) ? (
    <SectionRow {...props} />
  ) : isQuestionnaireResponseItemAnswer(props) ? (
    <QuestionRow {...props} />
  ) : null;

const QuestionnaireResponseTab = ({
  response,
}: {
  response: IQuestionnaireResponse;
}) => {
  return (
    <QuestionnaireResponseProvider
      questionnaireResponse={response}
      questionnaireResponseId={response.id || ''}>
      <QuestionnaireResponseContext.Consumer>
        {({ questionnaire, questionnaireResponse }) => (
          <ModalTab title={(questionnaire && questionnaire.title) || ''}>
            {questionnaireResponse && questionnaireResponse.item
              ? questionnaireResponse.item
                  .filter(it => isQuestionnaireResponseItemGroup(it))
                  .map(i => <Row key={i.linkId} {...i} />)
              : null}
          </ModalTab>
        )}
      </QuestionnaireResponseContext.Consumer>
    </QuestionnaireResponseProvider>
  );
};

const QuestionnaireResponseSidebar = () => {
  const { patient } = usePatient();
  const [questionnaireResponses, setQuestionnaireResponses] = useState<
    IQuestionnaireResponse[]
  >([]);

  useEffect(() => {
    const tsk = async () => {
      if (!patient || !patient.id) return;
      const response = await getQuestionnaireResponsesByPatientId(patient.id);
      if (response) setQuestionnaireResponses(response);
    };
    tsk();
  }, [patient]);
  return (
    <DashboardModalSidebar>
      <CristalScore />
      {questionnaireResponses.map(q => (
        <QuestionnaireResponseTab key={q.id} response={q} />
      ))}
    </DashboardModalSidebar>
  );
};
export default QuestionnaireResponseSidebar;
